import { render, staticRenderFns } from "./WaiveServiceFeeRewardEditor.vue?vue&type=template&id=2a4d64b4&scoped=true"
import script from "./WaiveServiceFeeRewardEditor.vue?vue&type=script&lang=ts"
export * from "./WaiveServiceFeeRewardEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4d64b4",
  null
  
)

export default component.exports